import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import {
  ClassbookDialogContext,
  SaveClassbookEntriesRequest,
} from '../models/classbook-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class DocentClassbookService {
  private readonly docentUrl = environment.apiUrl + '/classbook/docent';
  private readonly publicUrl = environment.apiUrl + '/classbook/public';

  constructor(private readonly httpClient: HttpClient) {}

  /**
   * @param docentName Fremder Name erfordert Meeting.Write bzw. Users.Read, sonst 403.
   * @param hash Gesetzt → öffentlicher Endpunkt (per Hash) statt angemeldeter Sitzung.
   */
  getContext(
    courseName: string,
    date: string,
    docentName?: string | null,
    hash?: string | null,
  ): Observable<ClassbookDialogContext> {
    let params = new HttpParams()
      .set('courseName', courseName)
      .set('date', date);

    if (hash) {
      params = params.set('hash', hash);
      return this.httpClient.get<ClassbookDialogContext>(
        `${this.publicUrl}/context`,
        { params },
      );
    }

    if (docentName) {
      params = params.set('docentName', docentName);
    }

    return this.httpClient.get<ClassbookDialogContext>(
      `${this.docentUrl}/context`,
      { params },
    );
  }

  /** Die Kurs-Id ermittelt das Backend selbst aus dem Kursnamen. */
  saveEntries(
    request: SaveClassbookEntriesRequest,
    hash?: string | null,
  ): Observable<{ saved: number; message: string }> {
    if (hash) {
      return this.httpClient.put<{ saved: number; message: string }>(
        `${this.publicUrl}/entries`,
        { ...request, hash },
      );
    }

    return this.httpClient.put<{ saved: number; message: string }>(
      `${this.docentUrl}/entries`,
      request,
    );
  }
}
